module.exports = __webpack_public_path__ + "static/facturacion-8e6224ec62ad6f47aab597026ebf8b74.svg";